"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeaderIcon = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../Icon");
var isHeaderIconObject = function (icon) {
    return typeof icon === 'object' && 'name' in icon;
};
exports.ModalHeaderIcon = function (props) {
    var icon = props.icon;
    if (isHeaderIconObject(icon)) {
        return react_1.default.createElement(Icon_1.Icon, { icon: icon.name, fill: icon.fill, size: 3 });
    }
    return react_1.default.createElement(Icon_1.Icon, { icon: icon, size: 3 });
};
//# sourceMappingURL=ModalHeaderIcon.js.map